<template>
  <!-- <div class="confirmPlaugin">
    <div class="confirmPlauginBox"> -->
  <div class="comfirmContent">
    <div class="amap-wrapper amap-page-container">
      <!-- <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box> -->
      <el-amap
        vid="amapDemo"
        :plugin="plugin"
        :center="center"
        :zoom="zoom"
        class="amap-box"
        :events="events"
      >
        <!-- <el-amap-marker v-for="(marker,ind) in markers" :position="marker" :key="ind"></el-amap-marker> -->
        <el-amap-marker :position="position"></el-amap-marker>
        <!-- <el-amap-text :text="text.text" :offset="text.offset"></el-amap-text> -->
      </el-amap>
    </div>
  </div>
  <!-- </div>
  </div> -->
</template>

<script>
export default {
  name: "mapdetail",
  components: {},
  props: {
    DTisShow: {
      type: Boolean
    },
    center: {
      type: Array
    },
    position: {
      type: Array
    },
    text: {
      type: Object
    }
  },
  mounted() {
    // this.mycenter  = [];
    // this.mycenter.push(this.center[0]);
    // this.mycenter.push(this.center[1]);
  },
  data() {
    return {
      // mycenter:[],
      coordinate: null,
      aoisName: "",
      confirmData: {},
      zoom: 12,

      // marker: [108.947885, 34.275721],
      // center: [108.947885, 34.275721],
      // markers: [{lng:108.947885,lat:34}],
      lng: 0,
      lat: 0,
      // searchOption: {
      //   city: "西安",
      //   citylimit: false
      // },
      range: "",
      options: [
        { value: "100", label: "100米" },
        { value: "200", label: "200米" },
        { value: "300", label: "300米" },
        { value: "400", label: "400米" },
        { value: "500", label: "500米" }
      ],
      address: "",
      plugin: [
        {
          pName: "ToolBar",
          // autoPosition: true,
          useNative: true,
          events: {
            init(instance) {}
          }
        }
      ],
      events: {
        // click(e) {
        //   let { lng, lat } = e.lnglat;
        //   self.lng = lng;
        //   self.lat = lat;
        //   // 这里通过高德 SDK 完成。
        //   var geocoder = new AMap.Geocoder({
        //     radius: 1000,
        //     extensions: "all"
        //   });
        //   geocoder.getAddress([lng, lat], function(status, result) {
        //     if (status === "complete" && result.info === "OK") {
        //       if (result && result.regeocode) {
        //         self.coordinate = result.regeocode;
        //         // 地图中得到坐标
        //         self.aoisName =
        //           result.regeocode.pois.length > 0
        //             ? result.regeocode.pois[0].name
        //             : "";
        //         self.address = result.regeocode.formattedAddress;
        //         self.$nextTick();
        //       }
        //     }
        //   });
        // }
      }
    }
  },
  methods: {
    addMarker: function() {
      let lng = 121.5 + Math.round(Math.random() * 1000) / 10000
      let lat = 31.197646 + Math.round(Math.random() * 500) / 10000

      this.markers.push([lng, lat])
    },
    // onSearchResult(pois) {
    //
    //   this.markers = [];
    //   let latSum = 0;
    //   let lngSum = 0;
    //   if (pois.length > 0) {
    //     pois.forEach(poi => {
    //       let { lng, lat } = poi;
    //       lngSum += lng;
    //       latSum += lat;
    //       this.markers.push([poi.lng, poi.lat]);
    //     });
    //     let center = {
    //       lng: lngSum / pois.length,
    //       lat: latSum / pois.length
    //     };
    //     this.center = [center.lng, center.lat];

    //     this.aoisName = pois[0].name;
    //     this.address = pois[0].address;
    //     this.lng = pois[0].lng;
    //     this.lat = pois[0].lat;
    //   }
    // },
    getContent(obj) {
      this.confirmData = obj
    },
    getCurrentRow(id) {
      this.id = id
    },
    createModelBtn() {
      this.$emit("getMapCoordinate", this.coordinate)
      if (
        this.lng !== 0 &&
        this.lat !== 0 &&
        this.aoisName !== "" &&
        this.address !== ""
      ) {
        let data = {
          lng: this.lng,
          lat: this.lat,
          aoisName: this.aoisName,
          address: this.address
        }
        this.$emit("affirmDt", true, data)
      } else {
        this.$message.error("请使用鼠标选取位置")
      }
    },
    modelShow() {
      this.$emit("affirmDt", false)
    }
  },
  created() {}
}
</script>
<style scoped lang="scss" rel="stylesheet/scss">
.comfirmConten {
  width: 1200px;
  height: 400px;
}
.amap-wrapper {
  width: 100%;
  height: 400px;
}
.confirmPlaugin {
  width: 100%;

  // position: fixed;
  // left: 0;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // background: rgba(0, 0, 0, 0.5);
  // z-index: 9999;
  .confirmPlauginBox {
    // width: 1150px;
    margin: 10% auto;
    height: auto;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid rgba(228, 231, 237, 1);
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
    .comfirmContent {
      // padding: 17px;
    }
  }
}

.amap-page-container {
  position: relative;
}
// .search-box {
//   width: 250px;
//   height: 40px;
//   position: absolute;
//   top: 10px;
//   right: 20px;
// }
.amap-demo {
  height: 300px;
}
.textColor {
  line-height: 30px;
  border-top: 1px solid #e9e9e9;
  box-sizing: border-box;
  padding-top: 10px;
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  span {
    line-height: 25px;
    .mapOption {
      z-index: 999;
    }
  }
}
</style>
